/* eslint-disable import/no-cycle */
/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import store from '../store';

const questions = {
  setup: ({ questionsData, predifinedAnswers }) => {
    const questionsList = {};

    Object.entries(questionsData).forEach((question) => {
      questionsList[question[0]] = questions.createQuestion({
        name: question[0],
        details: questionsData[question[0]],
        ...(predifinedAnswers) && { predifinedAnswers },
      });
    });

    store.dispatch({
      type: 'SET_QUESTIONS',
      payload: questionsList,
    });
  },
  createQuestion: ({ name, details, predifinedAnswers = null }) => {
    const savedAnswers = predifinedAnswers && predifinedAnswers[name];
    const age = store.getState().global.initialAge;
    const { options } = details;
    const newOptions = { ...options };
    if (age && name === 'goal' || name === 'being_home_alone') {
      Object.entries(newOptions).forEach((item) => {
        if (item[1].age && age !== item[1].age) {
          delete newOptions[item[1].value];
        }
      });
    }

    return {
      name: name || '',
      options: newOptions,
      answers: details.answers || savedAnswers || {},
    };
  },
  saveAnswersData: () => {
    const questionsList = store.getState().questions.list;

    const questionsToSave = {};

    Object.entries(questionsList).forEach((item) => {
      const answer = item[1].answers;

      Object.entries(answer).forEach((property) => {
        if (property[1].description) delete property[1].description;
        if (property[1].gender) delete property[1].gender;
      });

      questionsToSave[item[1].name] = answer;
    });

    store.dispatch({
      type: 'SAVE_ANSWERS',
      payload: questionsToSave,
    });
  },
  addAnswer: ({ questionName, answer }) => {
    const questionsList = { ...store.getState().questions.list };
    questionsList[questionName].answers = {
      ...questionsList[questionName].answers,
      [answer.value]: {
        ...answer,
      },
    };

    store.dispatch({
      type: 'SET_QUESTIONS',
      payload: questionsList,
    });

    questions.saveAnswersData();
  },
  addOnlyAnswer: ({ questionName, answer }) => {
    const questionsList = { ...store.getState().questions.list };

    questionsList[questionName].answers = {
      [answer.value]: {
        ...answer,
      },
    };

    store.dispatch({
      type: 'SET_QUESTIONS',
      payload: questionsList,
    });

    questions.saveAnswersData();
  },
  setAnswer: ({ questionName, answerName, answerValue }) => {
    const questionsList = { ...store.getState().questions.list };

    questionsList[questionName].answers = {
      ...questionsList[questionName].answers,
      [answerName]: answerValue,
    };

    store.dispatch({
      type: 'SET_QUESTIONS',
      payload: questionsList,
    });

    questions.saveAnswersData();
  },
  removeAnswer: ({ questionName, answer }) => {
    const questionsList = { ...store.getState().questions.list };

    delete questionsList[questionName].answers[answer.value];

    store.dispatch({
      type: 'SET_QUESTIONS',
      payload: questionsList,
    });

    questions.saveAnswersData();
  },
  toggleAnswer({ questionName, answer }) {
    const thisAnswerSelected = questions.isAnswerSelected({
      questionName,
      answer: answer.value,
    });

    if (!thisAnswerSelected) {
      questions.addAnswer({
        questionName,
        answer,
      });
    } else {
      questions.removeAnswer({
        questionName,
        answer,
      });
    }
  },
  isAnswerSelected({ questionName, answer }) {
    const questionsList = { ...store.getState().questions.list };

    return questionsList[questionName].answers[answer];
  },
  getAnswers({ questionName }) {
    const questionsList = { ...store.getState().questions.list };
    return questionsList[questionName] && questionsList[questionName].answers || null;
  },
  preventUnitsChanges({ name }) {
    const { preventUnitsChanges } = store.getState().questions;

    store.dispatch({
      type: 'PREVENT_UNITS_CHANGES',
      payload: {
        ...preventUnitsChanges,
        [name]: true,
      },
    });
  },
  getAgeAnswers() {
    const questionsList = store.getState().questions.list;

    return Object.fromEntries(
      Object.entries(questionsList)
        .filter(([name, question]) => name.toLowerCase().includes('age')
          && question.answers
          && Object.keys(question.answers).length > 0)
        .map(([name, question]) => [
          name,
          question.answers,
        ]),
    );
  },
};

export default questions;
